import { createClient } from '@supabase/supabase-js';

// Check for environment variables using import.meta.env
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Add debugging to see what we're getting
console.log('Supabase URL from env:', supabaseUrl ? 'Found' : 'Not found');
console.log('Supabase Anon Key from env:', supabaseAnonKey ? 'Found' : 'Not found');

// Fallback to hardcoded values if environment variables are not available
// This is only for development and testing - should be removed in production
const finalSupabaseUrl = supabaseUrl || 'https://kvhxnipttspnxxhbgnbq.supabase.co';
const finalSupabaseAnonKey = supabaseAnonKey || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt2aHhuaXB0dHNwbnh4aGJnbmJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY2MTUxMDMsImV4cCI6MjA1MjE5MTEwM30.Wq-BcWrXhr_qHPYQZoXwXNhavVEBKedITBQ4hPDlw6w';

if (!finalSupabaseUrl || !finalSupabaseAnonKey) {
  console.error('Supabase URL or Anon Key is missing even after fallback. Check your .env file.');
  throw new Error('Supabase URL or Anon Key is missing.');
}

// Determine origin for redirects
const appOrigin = window.location.origin;
const appRedirectUrl = `${appOrigin}/app`;

console.log('Using redirect URL for auth:', appRedirectUrl);

// Create the Supabase client with headers to prevent 406 errors
export const supabase = createClient(finalSupabaseUrl, finalSupabaseAnonKey, {
  global: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
}); 